__webpack_require__.p = "https://data-import-system-frontend.tst.studyportals.eu/dist/";